module.exports = __webpack_public_path__ + "img/127.9833e53c.jpg";